import React, { FC, useEffect } from 'react';
import { atom, useRecoilState, useSetRecoilState } from 'recoil';


const _snackBarMessage = atom<string | null>({
    key: 'snackbar',
    default: null,
});


export function useSnackBar() {
    const [snackBarMessage, setSnackBarMessage] = useRecoilState(_snackBarMessage);

    async function openSnackBar(message: string) {
        setSnackBarMessage(message);
    };

    function closeSnackBar() {
        setSnackBarMessage(null);
    };

    return { snackBarMessage, openSnackBar, closeSnackBar };
};


export const SnackBarProvider: FC = ({ children }) => {
    const { snackBarMessage, closeSnackBar } = useSnackBar();

    useEffect(() => {
        if (!snackBarMessage) return;
        async function close() {
            await new Promise<void>((resolve) => {
                setTimeout(() => resolve(), 3000);
            });
            closeSnackBar();
        };
        close();
    }, [snackBarMessage]);

    return (
        <div className="snackbar-area">
            {children}
            {snackBarMessage && (
                <div className="snackbar-wrapper">
                    <div className="message">
                        {snackBarMessage}
                    </div>
                </div>
            )}

            <style jsx>{`
                .snackbar-area {
                    poisition: relative;
                    min-height: ${window.innerHeight}px;
                }
                .snackbar-wrapper {
                    width: 100%;
                    height: 50px;
                    padding: 0 15px 0 15px;
                    position: fixed;
                    bottom: 80px;
                    z-index: 99;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .message {
                    width: 100%;
                    height: 100%;
                    border-radius: 40px;
                    color: #fff;
                    background-color: rgba(0, 0, 0, 0.7);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                @media screen and (min-width: 715px) {
                    .message {
                        width: 50%;
                    }
                }
            `}</style>
        </div>
    );
};
